import * as React from 'react';
import { LoaderProps, Loader } from '../Loader';
import { SvgLoading } from '../SvgLoading/SvgLoading';

export type SvgLoaderProps = Omit<LoaderProps, 'loadingComponent'>;

export const SvgLoader: React.FC<SvgLoaderProps> = ({ loading, ...props }) => (
    <Loader loading={loading} loadingComponent={<SvgLoading />} {...props} />
);
SvgLoader.displayName = 'SvgLoader';
